// HeroSlider.js

import React, { useState, useEffect } from "react";
import { useGetHomepageSlidersQuery } from "../../slices/homepageSlice";
import Loader from "../utilComponents/Loader";

const HeroSlider = () => {
  const { data: sliders, isLoading, isError } = useGetHomepageSlidersQuery();
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatically change the slide every 5 seconds
  useEffect(() => {
    if (sliders && sliders.length > 0) {
      const interval = setInterval(() => {
        nextSlide();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [currentIndex, sliders]);

  const nextSlide = () => {
    if (sliders && sliders.length > 0) {
      setCurrentIndex((prevIndex) =>
        prevIndex === sliders.length - 1 ? 0 : prevIndex + 1,
      );
    }
  };

  const prevSlide = () => {
    if (sliders && sliders.length > 0) {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? sliders.length - 1 : prevIndex - 1,
      );
    }
  };

  // Loading and error handling
  if (isLoading) {
    return (
      <div>
        <Loader count={1} columns={1} height="h-96" itemClass="w-[960px]" />
      </div>
    );

    // return <div>Loading...</div>;
  }

  if (isError) {
    return <div className="error">No sliders available</div>;
  }

  return (
    <div className="hero-slider flex-[5] rounded-lg relative group h-200 md:h-400 md:w-710">
      {/* Previous Arrow */}

      <button
        className="prev-button absolute left-4 top-1/2 transform -translate-y-1/2 text-3xl text-white bg-black/50 p-2 rounded-full hidden group-hover:block"
        onClick={prevSlide}
      >
        &#10094;
      </button>
      {/* Slides */}
      {sliders?.map((slider, index) => (
        <div
          key={slider._id}
          className={`hero-slide ${index === currentIndex ? "active" : "hidden"}`}
        >
          <img
            src={slider.image}
            alt={slider.title}
            className="w-full h-auto"
          />
          <div className="slide-content absolute bottom-8 left-8 text-white">
            {/* <h2 className="text-4xl">{slider.title}</h2>
            <p className="mt-4 text-lg">{slider.message}</p> */}
            <a
              href={slider.url}
              className="mt-4 inline-block text-lg  bg-agPrimary px-4 py-2 rounded-lg"
              // className="mt-4 inline-block text-lg underline"
            >
              Learn More
            </a>
          </div>
        </div>
      ))}
      {/* Next Arrow */}
      <button
        className="next-button absolute right-4 top-1/2 transform -translate-y-1/2 text-3xl text-white bg-black/50 p-2 rounded-full hidden group-hover:block"
        onClick={nextSlide}
      >
        &#10095;
      </button>
      {/* Dots */}
      <div className="dots absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {sliders?.map((_, index) => (
          <span
            key={index}
            className={`dot w-3 h-3 bg-gray-300 rounded-full cursor-pointer ${
              index === currentIndex ? "bg-white" : ""
            }`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
